<template>
  <footer
    :class="{
      'footer-wrapper bg-[linear-gradient(270deg,_#161616,_#373e47)]': true,
    }"
    data-testid="Footer"
  >
    <div
      :class="{
        'pt-80px': true,
      }"
    >
      <div
        :class="{
          'mx-auto flex w-full max-w-1760px flex-col justify-between px-3 lg:flex-row lg:px-6': true,
        }"
      >
        <LeftSideFooter v-bind="props" />
        <RightSideFooter v-bind="props" />
      </div>
    </div>

    <BottomFooter v-bind="props" />
  </footer>
</template>

<script lang="ts" setup>
import type { Footer } from '~/sanity/types';
import LeftSideFooter from '~/components/Molecules/FooterComponents/LeftSideFooter.vue';
import RightSideFooter from '~/components/Molecules/FooterComponents/RightSideFooter.vue';
import BottomFooter from '~/components/Molecules/FooterComponents/BottomFooter.vue';

const props = defineProps<Footer>();
</script>

<style></style>
